import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import { saveAs } from 'file-saver';

import Table from 'Components/Table';
import Icon from 'Components/Icon/Icon';
import logoDownload from '../../../../assets/dm-download.svg';
import logoPrint from '../../../../assets/dm-print.svg';
import formatDate from 'Shared/util/formatDate';
import formatPrice from 'Shared/util/formatPrice';
import CustomRowComponent from 'Components/CustomRowComponent/CustomRowComponent';

import { getInvoice, getIssued, getPaidDate, getTotal } from 'Shared/util/getColumns';

const TabInvoicesTable = ({ invoices }) => {
  const [openDownMenu, setOpenDownMenu] = useState(null);

  const handleEvent = (event, payload) => {
    event.preventDefault();

    switch (payload.type) {
      case 'setOpenDownMenu':
        setOpenDownMenu(payload.id);
        break;
      case 'download':
        saveAs(payload.url, `${payload.title}.pdf`);
        break;
      case 'print':
        window.open(payload.url, 'PRINT', 'height=400,width=600');
        break;
      default:
        console.error(`Warning: there are no such options (${payload.type}) `);
    }
  };

  const columns = [
    getInvoice(),
    getIssued(170),
    getPaidDate(170),
    getTotal(250),
    {
      cellProps: {
        Header: () => <span className="filter-title"> </span>,
        Cell: (props) => {
          const id = props.row._original.id;
          return (
            <>
              <span className="rt-td__head"> </span>
              <div className={'rt-td__cell'}>
                <div className="invoice-tab-nav-container">
                  <button
                    data-testid="btn-points"
                    className="invoice-tab-nav-container__btn-points"
                    onClick={(event) => handleEvent(event, { type: 'setOpenDownMenu', id })}
                  >
                    • • •
                  </button>
                  <div className="invoice-tab-nav-container__btn-next" data-testid="paid-invoice-details">
                    <Icon name="icon-right" />
                  </div>
                  <ul
                    data-testid="dropdown-menu"
                    className={cn('invoice-tab-nav-container__dropdown-menu', { 'action-menu': id === openDownMenu })}
                    onMouseLeave={(event) => handleEvent(event, { type: 'setOpenDownMenu', id: null })}
                    onClick={(event) => event.preventDefault()}
                  >
                    <li>
                      {props.row.download.url && (
                        <button
                          onClick={(event) =>
                            handleEvent(event, {
                              type: 'download',
                              url: props.row.download.url,
                              title: props.row.invoice.title,
                            })
                          }
                        >
                          <img src={logoDownload} alt="download" />
                          <span>Download</span>
                        </button>
                      )}
                    </li>
                    <li>
                      {props.row.download.url && (
                        <button onClick={(event) => handleEvent(event, { type: 'print', url: props.row.download.url })}>
                          <img src={logoPrint} alt="print" />
                          <span>Print</span>
                        </button>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </>
          );
        },
        accessor: 'download',
        width: 187,
        sortable: false,
      },
    },
  ];

  const mapColleaguesDataToRows = useCallback((invoices = []) => {
    const filteredInvoices = invoices.map(({ invoice, issued, paid_date, amount, download, id }) => {
      return {
        invoice: {
          title: invoice.reference ? invoice.reference : '-',
          desc: invoice.slug ? invoice.slug : '-',
        },
        issued: {
          title: issued.date ? `${formatDate(issued.date)}` : '-',
        },
        paid_date: {
          title: paid_date.date ? `${formatDate(paid_date.date)}` : '-',
        },
        total: {
          title: amount.number && amount.currency ? `${formatPrice(amount.number)} ${amount.currency}` : '-',
        },
        download: {
          url: download.url ? download.url : '',
        },
        id,
      };
    });

    return filteredInvoices;
  }, []);

  const tableSettings = {
    paginationHeight: 56,
    pageSize: window.innerWidth > 767 ? 10 : 3,
    CustomRowComponent: (props) => <CustomRowComponent url={'/customer/invoice/detail/'} {...props} />,
  };

  return (
    <div className="tab-invoices">
      {invoices && (
        <div className="table-wrap">
          <Table
            key="input-filter"
            sortable={false}
            tableSettings={tableSettings}
            columns={columns}
            data={mapColleaguesDataToRows(invoices)}
          />
        </div>
      )}
    </div>
  );
};

export default TabInvoicesTable;
